

export function convert_time(value) {
    let hour = Number(value.split(":")[0])
    let minute = Number(value.split(":")[1])
    if(hour === 12 && minute === 0) {
        return `오후 12시`
    }
    else if(hour > 12) {
        return `오후 ${String(hour - 12).padStart(2, "0")}시 ${String(minute).padStart(2, "0")}분`
    }
    else {
        return `오전 ${String(hour).padStart(2, "0")}시 ${String(minute).padStart(2, "0")}분`
    }
}